import { Uploader } from '../../../../../lib-sat/uploader/core/uploader.js';
import { createSatApi } from '../../../../../lib-sat/api/api.js';
import {
    GLOBAL_EVENT_JOB_CREATE_DONE,
    GLOBAL_EVENT_JOB_CREATE_FAIL,
    INPUT_EVENT_QUEUED,
    INPUT_EVENT_SUBMITTING,
    INPUT_EVENT_LOADING,
    INPUT_EVENT_DONE,
    INPUT_EVENT_FAIL,
    INPUT_EVENT_PASSWORD_MISSING,
    UPLOADER_EVENT,
} from '../../../../../lib-sat/uploader/core/event.js';
import { globalLogger } from '../../../../helper/global-logger.js';
import * as helper from './helper';
import 'blueimp-file-upload';
import { testIsGlobalEvent, testIsInputEvent } from '../../../../../lib-sat/uploader/core/test';
import { assertIsUploaderEvent } from '../../../../../lib-sat/uploader/core/assert';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import { registerPlaceholderToggle } from '../../../../../lib-sat/misc/misc';

/**
 * @type {?Uploader}
 */
var uploader = null;

function showErrorAndReset(message) {
    helper.showError(message);

    helper.hideLoadingAnimation();
    hideAddFileMenu();
}

/**
 * @param {String} event
 */
function globalEventCallback(event) {
    if (event === GLOBAL_EVENT_JOB_CREATE_DONE) {
        globalLogger.info('image editor - add layer create job done', uploader.getJob().getId());

        return;
    }

    if (event === GLOBAL_EVENT_JOB_CREATE_FAIL) {
        globalLogger.error('image editor - add layer create job fail');
    }
}

/**
 * @param {String} event
 */
function inputEventCallback(event) {
    if (event === INPUT_EVENT_QUEUED || event === INPUT_EVENT_SUBMITTING || event === INPUT_EVENT_LOADING) {
        helper.showLoadingAnimation();
        window.addingFile = true;

        return;
    }

    if (event === INPUT_EVENT_DONE) {
        var job = uploader.getJob();

        globalLogger.info('image editor - add layer input done', job.getId());

        var conversion = {
            target: 'png',
            options: {
                allow_multiple_outputs: true,
            },
        };

        uploader
            .getApiHelper()
            .addConversion(job.getId(), conversion)
            .done(function () {
                uploader
                    .getApiHelper()
                    .waitForCompletedJob(job.getId())
                    .done(function (response) {
                        /**
                         * @type {RawJobInfo}
                         */
                        var jobInfo = response;

                        for (var i = 0; i < jobInfo.output.length; i++) {
                            helper.toDataURL(jobInfo.output[i].uri, function (dataUrl) {
                                pixie.openFile(dataUrl, 'png');

                                helper.hideLoadingAnimation();
                                hideAddFileMenu();
                            });
                        }
                    })
                    .fail(function () {
                        showErrorAndReset();
                    });
            })
            .fail(function () {
                showErrorAndReset();
            });

        return;
    }

    if (event === INPUT_EVENT_FAIL || event === INPUT_EVENT_PASSWORD_MISSING) {
        globalLogger.error('image editor - add layer input fail', job.getId());

        showErrorAndReset();
    }
}

function openAddFileMenu() {
    $('navigation-bar').addClass('hidden');

    $('.add-file-menu-template')
        .clone()
        .addClass('add-file-menu')
        .removeClass('add-file-menu-template hidden')
        .appendTo('editor-controls');

    $('<input class="hidden" id="fileUploadInput" type="file" name="file">').appendTo('.add-file-menu');

    // always create a new uploader
    uploader = createUploader();

    eventBus.listen(UPLOADER_EVENT, (uploaderEvent) => {
        /** @type {UploaderEvent} */
        const _uploaderEvent = uploaderEvent;

        assertIsUploaderEvent(_uploaderEvent);

        if (testIsInputEvent(_uploaderEvent.event)) {
            inputEventCallback(_uploaderEvent.event);
        }

        if (testIsGlobalEvent(_uploaderEvent.event)) {
            globalEventCallback(_uploaderEvent.event);
        }
    });

    registerPlaceholderToggle();
}

function hideAddFileMenu() {
    $('navigation-bar').removeClass('hidden');

    uploader = null;

    $('.add-file-menu').remove();
    window.addingFile = false;
}

function init() {
    $(document).on('click', '.add-file-btn.upload', function () {
        try {
            $(window.uploaderConfig.fileUploadInputId).click();
        } catch (e) {
            globalLogger.error('image editor - uploader error', e);

            showErrorAndReset();

            return;
        }
    });

    $(document).on('click', '.add-file-btn.remote', function () {
        $('.add-file-menu .add-file-buttons').addClass('hidden');
        $('.add-file-menu .add-remote-url').removeClass('hidden');
    });

    $(document).on('click', '.add-remote-btn.cancel', function () {
        $('.add-file-menu .add-file-buttons').removeClass('hidden');
        $('.add-file-menu .add-remote-url').addClass('hidden');
    });

    $(document).on('click', '.add-remote-btn.confirm', function () {
        helper.showLoadingAnimation();
        window.addingFile = true;

        try {
            uploader.addExternalUrl($('input.add-remote-input').val());
        } catch (e) {
            globalLogger.error('image editor - uploader error', e);

            showErrorAndReset();
        }
    });

    $(document).on('click', '.add-file-btn.dropbox', function () {
        try {
            uploader.addDropbox();
        } catch (e) {
            globalLogger.error('image editor - uploader error', e);

            showErrorAndReset();
        }
    });

    $(document).on('click', '.add-file-btn.gdrive', function () {
        try {
            uploader.addGdrive();
        } catch (e) {
            globalLogger.error('image editor - uploader error', e);

            showErrorAndReset();
        }
    });

    $(document).on('click', '.add-file-menu .cancel-button', function () {
        hideAddFileMenu();
    });
}

function createUploader() {
    var api = createSatApi({});

    return new Uploader(api, window.uploaderConfig);
}

export { init };
export { openAddFileMenu };
export { hideAddFileMenu };
